export default __webpack_public_path__ + "static/media/stand.c9345248.svg";